<template>
  <v-main>
    <v-container grid-list-md fluid fill-height v-if="!isAuthenticated()">
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md5>
          <v-card class="elevation-12">
            <v-form ref="form" @submit.prevent="login">
              <v-toolbar dark color="primary">
                <v-toolbar-title>{{ $t('Login') }}</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-text-field v-model="user.username" :rules="[rules.required]" :disabled="loggingIn"
                  :label="t.Username" prepend-icon="person" name="login" type="text">
                </v-text-field>
                <v-text-field v-model="user.password" :rules="[rules.required]" :disabled="loggingIn"
                  :label="t.Password" prepend-icon="lock" name="password" id="password" type="password">
                </v-text-field>
                <div v-if="enable2StepsAuthentication || showEnterPincode">
                  <v-row align="center">
                    <v-col cols="5">
                      <v-text-field v-model="user.pincode" :disabled="loggingIn" :label="t.Pincode" prepend-icon="lock"
                        name="pincode" id="pincode">
                      </v-text-field>
                    </v-col>
                    <v-col cols="7" align="right">
                      <v-btn class="pa-2" outlined small color="secondary" @click="resendEmail()">
                        {{ $t("Resend email") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
              <v-card-actions class="flex-column pa-0">
              <!-- Row: Two login buttons side-by-side -->
              <div class="d-flex w-100 " style="gap: 16px;">
                <v-btn
                  color="#93D2ED"
                  @click="MSLoginAction"
                  class="flex-grow-1 mr-2"
                >
                  <v-icon left>login</v-icon>
                  MS {{ $t("Login") }}
                </v-btn>
                <v-btn
                  :disabled="loggingIn"
                  color="success"
                  type="submit"
                  class="flex-grow-1"
                >
                  {{ $t("Login") }}
                </v-btn>
              </div>

              <!-- Row: Single button centered -->
              <div class="d-flex justify-center w-100 mt-8  mb-4">
                <v-btn
                  :disabled="loggingIn"
                  outlined
                  small
                  color="secondary"
                  to="/resetpassword"
                >
                  {{ $t("Request new password") }}
                </v-btn>
              </div>
            </v-card-actions>
           </v-form>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import rules from '@/core/mixins/common-rules'
import * as Security from '@/core/security'
import { app } from '@/main'

export default {
  name: 'login',
  mixins: [rules],
  data () {
    return {
      user: {
        username: null,
        password: null
      },
      loggingIn: false,
      enable2StepsAuthentication: false,
      showEnterPincode: false
    }
  },
  async mounted () {
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    if (Security.user.corporationDetails) {
      this.enable2StepsAuthentication = (Security.user.corporationDetails.find(d => d.Name === 'Sys_Enable_2Steps_Authentication')?.Data1 === 'true')
    }

    // Jump from Login to Welcome if user is already logged in
    if (this.isAuthenticated()) {
      const routeTo = '/welcome'
      this.$router.push(routeTo)
    }
  },
  computed: {
    t () {
      return {
        Username: this.$t('Username'),
        Password: this.$t('Password'),
        Pincode: this.$t('Pin code')
      }
    }
  },
  methods: {
    isAuthenticated () {
      return Security.user.loggedIn
    },
    async login () {
      if (this.$refs.form.validate()) {
        this.loggingIn = true
        await Security.login({
          username: this.user.username,
          password: this.user.password,
          pincode: this.user.pincode,
          accessCode: null
        }).then(() => {
          this.loggingIn = false
          this.showEnterPincode = Security.EnterPinCode
          if (Security.PincodeIsWrong) app.$root.$message.showInfo(app.$t('Enter correct pin code received by e-mail'))
          else if (Security.PincodeIsOld) app.$root.$message.showInfo(app.$t('Enter new pin code received by e-mail'))
          else if (Security.EnterPinCode) app.$root.$message.showInfo(app.$t('Enter pin code received by e-mail'))
        })
      }
    },
    async MSLoginAction () {
      this.loggingIn = true
      await Security.loginViaMS().then(() => {
        this.loggingIn = false
      })
    },
    async resendEmail () {
      if (this.$refs.form.validate()) {
        await Security.resendPinCode({
          username: this.user.username
        }).then((res) => {
          if (!res.failed) {
            app.$root.$message.showInfo(app.$t('Enter pin code received by e-mail'))
          } else {
            setTimeout(function () { this.$router.go() }, 3000) // Lets refresh page in a moment
          }
        })
      }
    }

  }
}
</script>
